import { getController } from '@/controllers/request';
import { MODULE, ACTION } from '@/utils/constants';
import { mixin, errorMsg, callNotifications } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    notifications: null,
    newNotifications: null,
    hash: null,
    readed: [],
    readedPush: [],
    readedAll: false,
    notificationsSettings: null,
    loading: false
  },
  mixins: [mixin, errorMsg, callNotifications],
  mutations: {
    setLoading(state, value) {
      state.loading = value;
    },
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
    }
  },
  actions: {
    async fetchNotifications({ commit }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS,
            action: ACTION.LIST_VIEW,
            displayMode: 'spa'
          }
        });
        if (
          typeof response?.data === 'string' ||
          response.data instanceof String
        ) {
          throw new Error(response.data);
        }
        commit('setParam', {
          name: 'notifications',
          val: response?.data || {}
        });

        if (response.data?.bean?.id.value) {
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
        commit('setParam', {
          name: 'notifications',
          val: {
            error:
              'У Вас нет доступа к данной странице. Свяжитесь с вашим системным администратором для получения соответствующих прав.'
          }
        });
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchNewNotifications({ state, commit }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS,
            action: 'get_new_notifications',
            hash: state.hash
          }
        });
        commit('setParam', {
          name: 'newNotifications',
          val: response?.data?.notifications
        });
        commit('setParam', {
          name: 'hash',
          val: response?.data?.hash
        });

        if (response?.data?.bean?.id.value) {
          return true;
        } else {
          if (response?.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
        if (localStorage.getItem('auth') != 'true') {
          callNotifications.methods.updateNotifications(false);
        }
      }
    },
    async fetchNotificationsSettings({ commit }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS_SETTINGS,
            action: 'getNotificationsSettingPage',
            displayMode: 'spa'
          }
        });
        if (
          typeof response.data === 'string' ||
          response.data instanceof String
        ) {
          throw new Error(response.data);
        }
        commit('setParam', {
          name: 'notificationsSettings',
          val: response.data
        });

        if (response.data?.bean?.id.value) {
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
        commit('setParam', {
          name: 'notificationsSettings',
          val: {
            error:
              'У Вас нет доступа к данной странице. Свяжитесь с вашим системным администратором для получения соответствующих прав.'
          }
        });
      } finally {
        commit('setLoading', false);
      }
    },
    async readNotification({ dispatch, state, commit }, id) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS,
            action: ACTION.READ_NOTIFICATION,
            record: id
          }
        });

        if (response.data?.status !== 'error') {
          commit('setParam', {
            name: 'readed',
            val: [...state.readed, id]
          });
          dispatch('fetchNotifications');
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async readAllNotifications({ dispatch, commit }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS,
            action: ACTION.READ_NOTIFICATION,
            all_messages: true
          }
        });
        commit('setParam', {
          name: 'readedAll',
          val: true
        });

        if (response.data?.status !== 'error') {
          dispatch('fetchNotifications');
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async saveSettingAll({ commit, dispatch }, value) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS_SETTINGS,
            action: ACTION.SAVE_SETTING,
            value
          }
        });

        if (response?.data?.status == 'success') {
          await dispatch('fetchNotificationsSettings');
          return true;
        } else {
          if (response?.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async saveSettingCategoryAll({ commit, dispatch }, { category_id, value }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS_SETTINGS,
            action: ACTION.SAVE_SETTING,
            category_id,
            value
          }
        });

        if (response?.data?.status == 'success') {
          await dispatch('fetchNotificationsSettings');
          return true;
        } else {
          if (response?.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
    async saveSetting({ commit }, { setting_id, type, value }) {
      try {
        commit('setLoading', true);

        const response = await getController({
          params: {
            module: MODULE.HRPAC_NOTIFICATIONS_SETTINGS,
            action: ACTION.SAVE_SETTING,
            setting_id,
            type,
            value
          }
        });

        if (response?.data?.status == 'success') {
          return true;
        } else {
          if (response.data?.status == 'error') {
            errorMsg.methods.showNotification({
              offset: 100,
              showClose: true,
              message: response.data?.error?.error_text?.error || 'Ошибка',
              duration: 6500,
              type: 'error'
            });
          }
          return false;
        }
      } catch (e) {
        console.error(e);
      } finally {
        commit('setLoading', false);
      }
    }
  }
};
